module.exports = __webpack_public_path__ + "static/media/bodiometer-logo.ffb77e70.png";